import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyProfileNavigationService } from '../services/profile-routing/my-profile-navigation.service';

export const MY_PROFILE_ACTION = 'fitness-my-profile';
@DwAction({keyName: MY_PROFILE_ACTION, display: 'My Profile', actionType: DwActionType.menuAction,
    isGlobal: true, allowOnce: false, configData: {requireValidation: false, redirectAfter: false, actionMessage: ''}})
@Injectable()
export class MyProfileAction implements DwActionHandler {
    constructor(private navigation: MyProfileNavigationService) {}
    handleAction(): Observable<DwActionResult> {
        return this.navigation.open().pipe(map(opened => Object.assign(new DwActionResult(), {success: opened})));
    }
}
